import PropTypes from "prop-types";
import React, { useState } from 'react';
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { authProtectedRoutes, publicRoutes } from "./routes";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
// Import all middleware
import Authmiddleware from "./routes/route";
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import fakeBackend from "./helpers/AuthType/fakeBackend";
import notFound from "./admin/error/notFound";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Activating fake backend
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Toaster } from "react-hot-toast";
import "bootstrap-daterangepicker/daterangepicker.css";
import useNetworkStatus from './hooks/useNetworkStatus';
import ConnectionStatusOverlay from './components/ConnectionStatusOverlay';

fakeBackend();

const App = (props) => {
  const [isOffline, setIsOffline] = useState(false);

  useNetworkStatus(setIsOffline);

  function getLayout() {
    let layoutCls = VerticalLayout;
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = VerticalLayout; // HorizontalLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  }

  const Layout = getLayout();

  // Set Header
  // apiHeader();

  return (
    <React.Fragment>
      <Router>
        <Switch>
          {publicRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              exact
            />
          ))}
          <Route component={notFound} />
        </Switch>
      </Router>
      <NotificationContainer />
      <ToastContainer />
      <Toaster position="top-right" reverseOrder={false} />
      <ConnectionStatusOverlay isOffline={isOffline} />
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
